<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-toolbar flat color="white">
            <v-text-field style="width:100%" clearable flat solo v-model="search" prepend-icon="search" label="Быстрый поиск" single-line hide-details></v-text-field>
            <v-spacer></v-spacer>
            <v-btn icon flat @click="openFilter">
              <v-icon>mdi-filter</v-icon>
            </v-btn>
            <v-btn icon flat @click="openFilter">
              <v-icon>more_vert</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider />
          <v-data-table :headers="headers" :items="items" :search="search" :loading="loading" hide-actions>
            <v-progress-linear slot="progress" color="blue" height="3" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
              <td class="pa-2">{{ props.item.name }}</td>
              <td class="text-xs-center pa-2">{{ props.item.id }}</td>
              <td class="text-xs-center pa-2">{{ props.item.account_id }}</td>
              <td class="text-xs-center pa-2">
                <v-icon :color="props.item.status?'success':'error'">{{props.item.status ? 'mdi-check-outline' : 'mdi-cancel'}}</v-icon>
              </td>
              <td class="text-xs-center pa-2">{{ props.item.created }}</td>
              <td class="text-xs-center pa-2">{{ props.item.deleted }}</td>
              <td class="text-xs-center pa-2">
                <v-icon :color="props.item.default?'success':'error'">{{props.item.default ? 'mdi-check-outline' : 'mdi-cancel'}}</v-icon>
              </td>
              <td class="text-xs-center pa-2">
                <v-tooltip top>
                  <v-icon class="" @click="openCompanyForm(props.item)" slot="activator">mdi-domain</v-icon>
                  <span>Открыть карточку компании</span>
                </v-tooltip>
              </td>
            </template>
            <v-alert slot="no-results" :value="true" type="warning" class="black--text">
              По запросу "{{ search }}" ничего не найдено.
            </v-alert>
            <v-alert slot="no-data" :value="true" type="info">
              <span v-if="loading">Данные загружаются, пожалуйста подождите</span>
              <span v-else>Нет загруженных данных</span>
            </v-alert>
            <template slot="footer">
              <td :colspan="headers.length" class="text-xs-center body-2">Выбрано: {{items.length}} компаний</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" persistent :max-width="dialogWidth" scrollable>
      <component :is="currentComponent" v-if="dialog" v-bind="formProps" @close-dialog="dialog=false" @save="saveDialog"></component>
    </v-dialog>
  </v-container>
</template>

<script>
  import apiOrgstructure from '@/api/orgstructure'
  import FilterForm from './Forms/CompaniesFilterForm'
  import CompanyForm from './Forms/CompanyForm'
  
  export default {
    name : "CompaniesList",
    
    data(){
      return {
        dialog: false,
        loading: false,
        dialogWidth: 600,
        currentComponent: null,
        formProps: {},
        search: '',
        filter: {
          default: false,
          status: true
        },
        headers: [
          { text: 'Название', align: 'left', value: 'name' },
          { text: 'ID', align: 'center', value: 'id' },
          { text: 'Владелец', align: 'center', value: 'account_id', },
          { text: 'Активная', align: 'center', value: 'status' },
          { text: 'Дата создания', align: 'center', value: 'created' },
          { text: 'Дата удаления', align: 'center', value: 'deleted' },
          { text: 'ЛК', align: 'center', value: 'default' },
          { text: 'Операции', align: 'center', sortable: false, value: false, width: 60}
        ],
        items: [],
      }
    },
    
    created(){
      this.getCompaniesList()
    },
    
    methods:{
      openFilter(){
        this.dialogWidth = 600
        this.formProps = {
          data: this.filter
        }
        this.currentComponent = FilterForm
        this.dialog = true
      },
  
      getCompaniesList(){
        this.loading = true
        apiOrgstructure.companiesList(this.filter).then( response => {
          this.items = response
          this.loading = false
        })
      },
      
      openCompanyForm(item){
        this.dialogWidth = 600
        this.formProps = {
          data: item
        }
        this.currentComponent = CompanyForm
        this.dialog = true
      },
      
      saveDialog(eventData){
        switch(eventData.type){
          case 'filter':
            this.filter = eventData.data
            this.getCompaniesList()
            break
          case 'updateCompany':
            let index = this.items.findIndex(el=>el.id===eventData.data.id)
            if(index>=0){
              Object.assign(this.items[index], eventData.data)
            }
            break
          case 'deleteCompany':
            let i = this.items.findIndex(el=>el.id===eventData.data.id)
            if(i>=0){
              if(eventData.data.hard){
                this.items.splice(i, 1)
              } else {
                this.items[i].status = false
              }
            }
            break
          case 'restoreCompany':
            let j = this.items.findIndex(el=>el.id===eventData.data.id)
            if(j>=0){
              this.items[j].status = true
            }
            break
        }
        this.dialog = eventData.dialog || false
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/orgstructure/components/CompaniesList.vue